import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  templateUrl: './formly-persist-button.component.html',
  standalone: true,
  imports: [
    ButtonModule,
    TooltipModule,
    TranslatePipe,
  ]
})
export class FormlyPersistButtonComponent extends FieldWrapper {
  @ViewChild('fieldComponent', { read: ViewContainerRef })
  fieldComponent: ViewContainerRef;

  isPersisted = false;

  constructor() {
    super();
  }

  persist() {
    if (!this.isPersisted) {
      if (!this.options.formState.persistedValue)
        this.options.formState.persistedValue = {};
      this.options.formState.persistedValue[this.key.toString()] = this.formControl.value;
      this.options.updateInitialValue(this.options.formState.persistedValue);
      this.formControl.disable();
      this.isPersisted = true;
    }
    else {
      if (this.options.formState.persistedValue !== undefined)
        delete this.options.formState.persistedValue[this.key.toString()];
      this.options.updateInitialValue(this.options.formState.persistedValue);
      this.isPersisted = false;
      this.formControl.enable();
    }
  }
}